function ReleaseNotesViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  self.ignore = ko.observable(false);
  self.notes = ko.observableArray([]);
  self.visible = ko.observable(false);

  self.store = new Store();


  /**
   * Inspects the last known version and compares it to the
   * current version
   *
   * @method checkToShow
   * @returns none
   */
  self.checkToShow = function () {
    // Get the current application version
    var appVersion = self.parent.version();
    // Get a stored version
    var lastKnownVersion = self.store.get('calendarVersion');
    // Get a user preference
    var ignoreReleaseNotes = self.parseBoolean(self.store.get('ignoreReleaseNotes'));
    // Get the latest version from the notes
    var latestNotesVersion = self.notes()[0].version;

    if (!ignoreReleaseNotes || ignoreReleaseNotes === false) {
      if (appVersion === latestNotesVersion) {
        if (!lastKnownVersion || lastKnownVersion !== appVersion) {
          self.showReleaseNotes();
          return;
        }
      }
    }

    self.reset();
  };


  /**
   * Hides the interface
   *
   * @method hide
   * @returns none
   */
  self.hide = function () {
    self.storeIgnore();
    self.store.set('calendarVersion', self.parent.version());

    self.reset();
  };


  /**
   * Method tries to see if the app version needs to or can
   * be shown to the user
   *
   * @method init
   * @returns none
   */
  self.init = function () {
    var ignoreReleaseNotes = self.parseBoolean(self.store.get('ignoreReleaseNotes'));
    if (ignoreReleaseNotes) {
      self.ignore(true);
    }

    self.loadReleaseNotes(self.checkToShow);
  };


  /**
   * First loads the release notes JSON and then calls for
   * the interface to be displayed
   *
   * @method loadReleaseNotes
   * @param {Function} callback
   * @returns none
   */
  self.loadReleaseNotes = function (callback) {
    $.ajax({
      method: 'get',
      url: 'res/config/releasenotes.json',
      dataType: 'json',
      success: function (data) {
        self.notes(data);
        if (callback) {
          callback();
        }
      },
      error: function (jqXHR, textStatus, statusMessage) {
        console.log('error', textStatus, statusMessage);
      }
    });
  };


  /**
   * Resets the view model to it's initial state
   *
   * @method reset
   * @returns none
   */
  self.reset = function () {
    self.visible(false);
    self.notes.removeAll();
  };


  /**
   * Calls for the release notes to be loaded and then
   * asks for the UI to be presented
   *
   * @method show
   * @returns none
   */
  self.show = function () {
    self.loadReleaseNotes(self.showReleaseNotes);
  };



  /**
   * Presents the UI for the release notes
   *
   * @method showReleaseNotes
   * @returns none
   */
  self.showReleaseNotes = function () {
    self.visible(true);
  };


  /**
   * Commits the ignore variable to storage
   *
   * @method storeIgnore
   * @returns none
   */
  self.storeIgnore = function () {
    self.store.set('ignoreReleaseNotes', self.ignore() === true);
  };

  return self;
};

ReleaseNotesViewModel.prototype = AbstractViewModel.prototype;
ReleaseNotesViewModel.prototype.constructor = ReleaseNotesViewModel;
